import React from 'react';
import { useTranslation } from 'react-i18next';

interface HeroImagePagerProps {
  /** Zero-based index of the image shown. */
  index: number;
  count: number;
  onChange: (index: number) => void;
}

/**
 * Arrows to browse the start page's hero images, the same as on etappio.se
 * (ClickUp 869fkgc63). The images are CSS backgrounds (.landing-hero--N in
 * App.css), so this only chooses the index; browsing wraps both ways.
 */
export function HeroImagePager({ index, count, onChange }: HeroImagePagerProps) {
  const { t } = useTranslation();
  const step = (delta: number) => onChange((index + delta + count) % count);

  return (
    <div className="landing-hero-pager" role="group" aria-label={t('landing.heroPager.label')}>
      <button type="button" className="landing-hero-pager-btn" onClick={() => step(-1)} aria-label={t('landing.heroPager.prev')}>
        <i className="bi bi-chevron-left" aria-hidden="true"></i>
      </button>
      <span className="landing-hero-pager-count" aria-live="polite">
        {index + 1} / {count}
      </span>
      <button type="button" className="landing-hero-pager-btn" onClick={() => step(1)} aria-label={t('landing.heroPager.next')}>
        <i className="bi bi-chevron-right" aria-hidden="true"></i>
      </button>
    </div>
  );
}
